import React, { useState } from "react";
import classes2 from "../components/Tools/Tools-CSS/CSPQuickAccountLookup.module.css";
import CommonGrid from "../components/CommonGrid";
import { toast } from "react-toastify";
import axios from "../axios";
import urls from "../Utils/urls";
import { commonToast } from "../Utils";
import { FloatLabel, LoanAccCustomNewTabCell } from "../Utils/CustomComponent";
import Select from "react-select";
import { useForm } from "react-hook-form";

const CustomerServicePortalSearch = () => {
  const [columnData, setColumnData] = useState(null);
  const [input, setInput] = useState("RMF4032554");
  const { register, handleSubmit } = useForm({
    defaultValues: {
      MonthlyPaymentFrom: 0,
      MonthlyPaymentTo: 0,
    },
  });

  const handleFinalSubmit = async (e) => {
    const id = toast.loading("Searching Loan");
    setColumnData(null);
    try {
      const { data } = await axios.post(
        urls.customerService.postSearchLoans(),
        {
          AccountNo: input,
          MonthlyPaymentTo: Number(e.MonthlyPaymentTo),
          MonthlyPaymentFrom: Number(e.MonthlyPaymentFrom),
          ...e,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (data?.[0]?.length) {
        setColumnData(data[0]);
        toast.update(id, {
          render: "Loan Searched Succesfuly",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
      } else {
        setColumnData([]);
        toast.update(id, {
          render: "Loan Searched Succesfuly",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
      }
    } catch (error) {
      console.error(error);
      toast.update(id, {
        render: "Error",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      setTimeout(() => {
        toast.dismiss();
      }, 1000);
    }
  };

  return (
    <div>
      <section
        className="rounded"
        style={{ background: "#eeeeee", minHeight: "100vh", padding: "10px" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0 mt-1">
            <h4>Customer Service Portal Dashboard</h4>
          </div>
          <div className={classes2.accountLookupDetails}>
            <div style={{ background: "#fff", height: "100%" }}>
              <form onSubmit={handleSubmit(handleFinalSubmit)}>
                <div className="d-flex gap-4">
                  <FloatLabel
                    divClassName={"d-flex"}
                    label={"Select Account"}
                    value={"asdfsfd"}
                  >
                    <div
                      className="d-flex align-items-center p-5"
                      style={{ border: "1px solid #777" }}
                    >
                      <label className="me-5">Account Number: </label>
                      <div className="me-5">
                        <input
                          value={input}
                          onChange={(e) => setInput(e.target.value)}
                          className="p-0 m-0 ps-3"
                        />
                      </div>
                      <div>
                        <button
                          className="btn btn-primary text-white btn-outline py-4"
                          style={{ width: "100px" }}
                          type="submit"
                          onClick={handleSubmit(handleFinalSubmit)}
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  </FloatLabel>
                  <FloatLabel
                    divClassName={"d-flex"}
                    label={"Last 10 Account"}
                    value={"asdfsfd"}
                  >
                    <div
                      className="p-5"
                      style={{ border: "1px solid #000", width: "25rem" }}
                    >
                      <Select
                        options={[{ label: "Account", value: "Account" }]}
                        value={{ label: "Account", value: "Account" }}
                        // onChange={handleAccountChange}
                        classNamePrefix="select"
                      />
                    </div>
                  </FloatLabel>
                </div>
                <div>
                  <FloatLabel label={"Search for Account"} value={"asdfsfd"}>
                    <div
                      className="d-flex p-5"
                      style={{ border: "1px solid #777" }}
                    >
                      <div className="d-flex flex-column border p-5 w-75">
                        {accountFormData?.map((inputProps, index) => (
                          <div key={index} className="d-flex mb-4">
                            <label
                              style={{
                                minWidth: "15rem",
                                textAlign: "end",
                                marginRight: "1rem",
                              }}
                            >
                              {inputProps?.label}:
                            </label>
                            <input
                              type={inputProps?.type || "text"}
                              style={inputProps.style}
                              {...register(inputProps.field)}
                              className="me-5"
                            />
                            {inputProps.sameline && (
                              <>
                                <label
                                  style={{
                                    minWidth: "5rem",
                                    textAlign: "end",
                                    marginRight: "1rem",
                                  }}
                                >
                                  {inputProps?.label1}:
                                </label>
                                <input
                                  type={inputProps?.type1 || "text"}
                                  style={inputProps.style1}
                                  {...register(inputProps.field1)}
                                />
                              </>
                            )}
                          </div>
                        ))}
                        <div className="d-flex justify-content-end">
                          <button
                            className="btn btn-primary text-white btn-outline py-4"
                            style={{ width: "100px" }}
                            type="submit"
                            onClick={handleSubmit(handleFinalSubmit)}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </div>
                  </FloatLabel>
                </div>
              </form>
              {columnData ? (
                <CommonGrid
                  title={"Loans"}
                  tHeight={"40vh"}
                  gridColumns={gridColumn}
                  columnData={columnData ? columnData : null}
                />
              ) : null}
            </div>
          </div>
        </article>
      </section>
    </div>
  );
};

export default CustomerServicePortalSearch;
const gridColumn = [
  {
    field: "Lender",
    title: "Lender",
    Cell: (props) => <LoanAccCustomNewTabCell props={props} keyStr="Lender" />,
  },
  {
    field: "Lender Principal Investment",
    title: "Lender Principal Investment",
  },
  {
    field: "Loan Account",
    title: "Loan Account",
    Cell: (props) => (
      <LoanAccCustomNewTabCell props={props} keyStr="Loan Account" />
    ),
  },
  { field: "Next Due Date", title: "Next Due Date" },
  { field: "property address", title: "Property Address" },
];
const accountFormData = [
  {
    label: "Associated Name (Last or Co)",
    field: "AssociatedName",
    style: { width: "70%" },
  },
  { label: "Tax ID #", field: "TaxId", style: { width: "20%" } },
  {
    label: "Name Alternate ID",
    field: "NameAlternateID",
    style: { width: "30%" },
  },
  { label: "Loan Name", field: "LoanName", style: { width: "50%" } },
  {
    label: "Monthly Payment",
    field: "MonthlyPaymentFrom",
    type: "number",
    style: { width: "20%" },
    sameline: true,
    label1: "To",
    type1: "number",
    field1: "MonthlyPaymentTo",
    style1: { width: "20%" },
  },
  {
    label: "Additional Loan ID",
    field: "AdditionalLoanID",
    style: { width: "20%" },
  },
  {
    label: "Investor Loan #",
    field: "InvestorName",
    style: { width: "20%" },
  },
  { label: "Contact Name", field: "COntactName", style: { width: "50%" } },
  {
    label: "Contact Email",
    field: "ContactEmail",
    style: { width: "30%" },
    sameline: true,
    label1: "Phone",
    field1: "Phone",
    style1: { width: "20%" },
  },

  {
    label: "Parcel Number",
    sameline: true,
    field: "ParcelNo",
    style: { width: "20%" },
    label1: "Policy #/FHA Case #",
    field1: "PolicyFHACase",
    style1: { width: "20%" },
  },
];
